import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);

  // On the landing page the header floats transparent over the blue hero and
  // gains a dark background once you scroll (GitHub-homepage behaviour).
  useEffect(() => {
    if (!isLanding) return;
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isLanding]);

  const headerClass = isLanding
    ? `header header-landing ${scrolled ? 'header-scrolled' : ''}`
    : 'header';

  return (
    <header className={headerClass}>
      <div className="container">
        <div className="header-content">
          <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <span className="logo-text">Inflection</span>
          </div>
          {/* Signed-out visitors get this week's public list, not /trends,
              which they cannot open. The account is the capture — Clerk
              already has the email, so there is no second form. */}
          <SignedOut>
            <nav className="nav">
              <span
                className={`nav-link ${location.pathname === '/preview' ? 'active' : ''}`}
                onClick={() => navigate('/preview')}
              >
                This week
              </span>
            </nav>
          </SignedOut>
          <div className="header-right">
            <SignedIn>
              <UserButton afterSignOutUrl="/" />
            </SignedIn>
            <SignedOut>
              <button className="signin-btn" onClick={() => navigate('/signin')}>
                Sign In
              </button>
              <button className="signup-btn" onClick={() => navigate('/signup')}>
                Sign Up
              </button>
            </SignedOut>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
